export const ON_COOKIE_OPENED = 'cookie:opened';
export const ON_COOKIE_CLOSED = 'cookie:closed';
export const ON_COOKIE_ACCEPTED = 'cookie:accepted';
export const ON_COOKIE_DECLINED = 'cookie:declined';
